// extracted by mini-css-extract-plugin
module.exports = {"faqContainer":"styles_faqContainer__Ga8Et","title":"styles_title__UVXA5","faqSection":"styles_faqSection__WiG3Y"};